import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'react-bootstrap';
import snakecaseKeys from 'snakecase-keys';

import TaskForm from 'components/tasks/task_form';
import { partition } from 'lodash';

export default class BulkTasksModal extends React.Component {
  static propTypes = {
    availableDatabases: PropTypes.array.isRequired,
    currentUser: PropTypes.shape({
      id: PropTypes.number.isRequired
    }).isRequired,
    databaseMembers: PropTypes.array.isRequired,
    defaultAssociatedModels: PropTypes.array.isRequired,
    hideByProjectSelect: PropTypes.bool,
    hideContactSelect: PropTypes.bool,
    hideProjectSelect: PropTypes.bool,
    isLogged: PropTypes.bool,
    selectedContacts: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      unloaded: PropTypes.bool
    })).isRequired,
    shown: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
  };

  title() {
    if (this.props.isLogged) return 'Log Activities ';
    return 'Create Tasks ';
  }

  render() {
    const { shown, selectedContacts, onCancel } = this.props;
    return (
      <Modal backdrop="static" className="bulk-tasks-modal" show={shown} onHide={onCancel}>
        <Modal.Header closeButton>
          <Modal.Title>{this.title()} from {selectedContacts.length} Contacts</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderTaskForm()}
        </Modal.Body>
      </Modal>
    );
  }

  renderTaskForm() {
    const {
      availableDatabases,
      currentUser,
      databaseMembers,
      defaultAssociatedModels,
      hideByProjectSelect,
      hideContactSelect,
      hideProjectSelect,
      selectedContacts,
      onCancel,
      onSubmit
    } = this.props;

    const defaultAssignee = snakecaseKeys(databaseMembers.find(member => member.id === currentUser.id) || {});
    const [unloaded, loaded] = partition(selectedContacts, contact => contact.unloaded);

    let selected = loaded.map(contact => contact.name).join(', ');

    if (unloaded.length > 0) {
      selected += `, and ${unloaded.length} more`;
    }

    return (
      <TaskForm
        assigneeOptions={snakecaseKeys(databaseMembers)}
        availableDatabaseOptions={availableDatabases}
        defaultAssociatedModels={defaultAssociatedModels}
        defaultTaskAssignee={defaultAssignee}
        hideByProjectSelect={hideByProjectSelect}
        hideContactSelect={hideContactSelect}
        hideProjectSelect={hideProjectSelect}
        logTask={this.props.isLogged}
        providedTitle="Call with [{Contact}]"
        selectedContacts={selected}
        onCancel={onCancel}
        onSave={onSubmit}
      />
    );
  }
}
